<template>
<div>
    <Breadcrumb :title="'Footnotes'"></Breadcrumb>
    <div>
        <BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
    </div>
    <div class="btnDiv">
        <BaseToolBar :config="ToolbarConfig" @buttonClicked="toolbarOnClick"></BaseToolBar>
    </div>
    <div>
        <FootnotesForm :ref="'FootnotesForm'" :FootnotesInfo="FootnotesJSON" :FootnotesModalLabel="modalConfig"></FootnotesForm>
    </div>
    <div>
        <BaseGrid :config="GridConfig" :mode="'editform'" @EditItem="EditFootnotes" @DeleteItem="DeleteFootnote"></BaseGrid>
    </div>
</div>
</template>

<script>
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import {
    ToolbarConfig
} from "./FootnoteConfig.js";
import BaseModelFootnote from "@/models/BaseModelFootnote.js";
import FootnotesForm from "@/components/forms/FootnotesForm.vue";
import funcUtil from "@/services/funcUtil.js";
import toolbarUtility from "@/services/toolbarUtility.js";
import {
    mapGetters, mapActions
} from 'vuex';

export default {
    name: "Footnotes",
    components: {
        Breadcrumb,
        BaseGrid,
        FootnotesForm,
        BaseToolBar,
        BaseSearchBar
    },
    mixins: [funcUtil, toolbarUtility],
    data: function () {
        return {
            GridConfig: BaseModelFootnote,
            modalConfig: {
                modalName: "",
                modalAddorEdit: ""
            },
            ToolbarConfig: ToolbarConfig,
            search: {
                SearchData: "",
            },
            FootnotesJSON: {},
            FootnoteMasterData: {}
        };
    },
    computed: {
        ...mapGetters("getModule", ["withFilter"])
    },
    mounted() {
        this.FootnoteMasterData = JSON.parse(
            JSON.stringify(
                $("#FootnoteGrid")
                .data()
                .kendoGrid.dataSource.data()
            ));
       
       let _self = this;
       setTimeout(function(){

                let kgrid = $("#FootnoteGrid").data("kendoGrid")
                kgrid.dataSource.data(_self.$store.state.getModule.Footnote)
        },500)
    },
    methods: {
        ...mapActions("postModule",['DeleteItem']),
        EditFootnotes(e) {
            let self = this;
            e.preventDefault();
            this.modalConfig.modalName = "Edit Footnote";
            this.modalConfig.modalAddorEdit = "edit";
            var gview = window.$("#FootnoteGrid").data("kendoGrid");
            var dataItem = JSON.parse(JSON.stringify(gview.dataItem(window.$(e.currentTarget).closest("tr"))));
            this.$refs.FootnotesForm.pageErrors = [];
            this.$refs.FootnotesForm.FootnoteID = dataItem.FootnoteID;
            this.$refs.FootnotesForm.Footnote = dataItem.Footnote;
            self.FootnotesJSON = dataItem;
            window.$("#BaseModal").modal("toggle");
        },
        DeleteFootnote(e) {
            let self=this;
            e.preventDefault();
            let gview = window.$("#FootnoteGrid").data("kendoGrid");
            let dataItem = gview.dataItem(
                    window.$(e.currentTarget).closest("tr")
            );
            const message = "Are you sure you want to delete this record?";
            this._ConfirmationPopup(message, "DELETE").then(result => {
                if (result.value) {
                //let loader = this.$loading.show();
                this._APICrudPopup("APICrudpopup");
                let deleteData = { Id: dataItem.Id };
                let ItemsToBeDeleted = { list:BaseModelFootnote, payload:deleteData }
                this.DeleteItem(ItemsToBeDeleted).then(response => {
                    $("#FootnoteGrid").data().kendoGrid.dataSource.read();
                    this._AlertPopup("Deleted successfully!","success");
                }).catch(error=>{
                    this._AlertPopup("Some Error Occurred!","info");
                }).finally(()=>{
                    //loader.hide();
                })
                }
            });
        },
        filterGrid(e) {
            let self = this;

            let filteredData = this._filterGrid(
                this.FootnoteMasterData,
                this.search.SearchData
            );

            //Filter by a column
            $("#FootnoteGrid")
                .data("kendoGrid")
                .dataSource.data(filteredData);
        },
        toolbarOnClick(e) {
            e.preventDefault();
            switch (e.id) {
                case "btnAddFootnote":
                    this.AddFootnote();
                    window.$("#BaseModal").modal("toggle");
                    break;
                case "tagFMVStatement":
                    this.$router.push("/valuation/fmvs/footnote");
                    break;
                case "btnBulkImportFootnote":
                    this.$router.push("/valuation/footnote/upload");       
                    break; 
            }
            this._baseToolBarEvents("FootnoteGrid", ...arguments);
        },
        AddFootnote: function () {
            this.modalConfig.modalName = "Add Footnote";
            this.modalConfig.modalAddorEdit = "add";
            var FootnotesJSON = {
                FootnoteID: "",
                Footnote: ""
            };

            this.$refs.FootnotesForm.pageErrors = [];
            this.$refs.FootnotesForm.FootnoteID = "";
            this.$refs.FootnotesForm.Footnote = "";
            const result = this.withFilter(BaseModelFootnote.list, "");
            FootnotesJSON.FootnoteID = (result.length <= 0) ? 700001 : this._getIncrementalID(result, "FootnoteID");
            this.FootnotesJSON = FootnotesJSON;
        },
    }
}
</script>

<style>
</style>
